module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "intro"
  }, [_c('div', {
    staticClass: "wrap"
  }, [_c('div', {
    staticClass: "loading-bg scroll-wrapper"
  }, [_c('iframe', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoaded),
      expression: "isLoaded"
    }],
    attrs: {
      "id": "intro-iframe",
      "src": _vm.url,
      "width": "100%",
      "height": "100%"
    },
    on: {
      "load": function($event) {
        _vm.isLoaded = true
      }
    }
  })], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d0800c98"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Intro.vue
// module id = 981
// module chunks = 1